import { ENV } from '@/constants';

import { BtcLikeNetwork, NetworkNet } from '../common';

import { getSatPerVbEstimateFee } from './api';

export const LtcNetworkSettings = {
  [NetworkNet.Mainnet]: {
    bech32: 'ltc',
    pubKeyHash: 0x30,
    scriptHash: 0x32,
    wif: 0xb0,
  },
  [NetworkNet.Testnet]: {
    bech32: 'tltc',
    pubKeyHash: 0x6f,
    scriptHash: 0x3a,
    wif: 0xef,
  },
} as const;

const LtcExplorerMap: Record<NetworkNet, string> = {
  [NetworkNet.Mainnet]: 'https://litecoinspace.org',
  [NetworkNet.Testnet]: 'https://litecoinspace.org/testnet',
};

const isLtcNetwork = (value: string): value is NetworkNet => (Object.values(NetworkNet) as string[]).includes(value);
const mempoolApiEndpoint = (ENV['VITE_LTC_MEMPOOL_API_ENDPOINT'] as string)
  .split('/')
  .map((slug) => (slug[0] === '$' ? (ENV[slug.slice(1)] as string) : slug))
  .join('/');

export const NETWORK: BtcLikeNetwork = {
  get Network() {
    if (!isLtcNetwork(ENV['VITE_LTC_NETWORK'])) {
      throw new Error(
        'Incorrect value ' +
          ENV['VITE_LTC_NETWORK'] +
          ' for variable VITE_LTC_NETWORK. Use one of ' +
          Object.values(NetworkNet).join(', ')
      );
    }

    return ENV['VITE_LTC_NETWORK'];
  },

  get BlockstreamApiEndpoint() {
    return (ENV['VITE_LTC_BLOCKSTREAM_API_ENDPOINT'] as string)
      .split('/')
      .map((slug) => (slug[0] === '$' ? (ENV[slug.slice(1)] as string) : slug))
      .join('/');
  },

  get MempoolApiEndpoint() {
    return mempoolApiEndpoint;
  },

  get Settings() {
    return LtcNetworkSettings[NETWORK.Network];
  },

  get MempoolSpendingUtxoEndpoint(): string {
    return (ENV['VITE_LTC_SPENDING_UTXO_ENDPOINT'] as string)
      .split('/')
      .map((slug) => (slug[0] === '$' ? (ENV[slug.slice(1)] as string) : slug))
      .join('/');
  },

  get ExplorerUrl() {
    const network = this.Network;

    return LtcExplorerMap[network];
  },

  get DustLimit() {
    return Number(ENV['VITE_LTC_DUST_LIMIT']);
  },

  get FeeCorrection() {
    return BigInt(Number(import.meta.env['VITE_LTC_FEE_CORRECTION'] || 1));
  },

  api: {
    getSatPerVbEstimateFee: () => getSatPerVbEstimateFee(mempoolApiEndpoint),
  },
};
